var React = require('react');

function ArticleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 5.28571V1.64286C1 1.28782 1.28782 1 1.64286 1H21.7857C22.1408 1 22.4286 1.28782 22.4286 1.64286V5.28571M1 5.28571V15.3571C1 15.7122 1.28782 16 1.64286 16H21.7857C22.1408 16 22.4286 15.7122 22.4286 15.3571V5.28571M1 5.28571H22.4286","stroke":"#021546","strokeWidth":"0.902355","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArticleInline.defaultProps = {"width":"23","height":"17","viewBox":"0 0 23 17","fill":"none"};

module.exports = ArticleInline;

ArticleInline.default = ArticleInline;
